// @vendors
import React, { useEffect } from 'react'
import Highcharts from 'highcharts'

// @styles
import './ChartVentasUltimoMes.css'

// @utils
import { setearMiles } from 'util/utils'
import { formatearFecha } from 'util/formatDate'
import moment from 'moment'

interface Props {
    data: any[]
    type: 'line' | 'area'
    color?: string
    length: 1 | 2 | 3
    updateData: number
    showCurrency?: boolean
    containerId?: string
}


const ChartVentasUltimoMes = ({ data, type, color, length, updateData, showCurrency = true, containerId = 'container__chartMensuales' }: Props) => {
    const startDate = moment().subtract(3, 'months');
    const crearGrafica = () => {
        const options = {
            credits: {
                enabled: false
            },
            chart: {
                type: type,
                series: {
                    color: color
                }
            },
            title: {
                text: ''
            },
            yAxis: {
                title: {
                    text: ''
                },
                labels: {
                    formatter: function (this: any) {
                        const value = setearMiles(this.value ?? 0)
                        return showCurrency ? '$' + value : value
                    },
                    tooltip: {
                        formatter(this: Highcharts.TooltipFormatterContextObject) {
                            return ' $ ' + setearMiles(this.point.y ?? 0)
                        }
                    }
                }
            },
            xAxis: {
                type: 'datetime',
                title: {
                    style: { color: 'black', fontSize: '1.2rem' }
                },
            },

            plotOptions: {
                series: {
                    pointInterval: 2592000000, // One Month
                    pointStart: startDate.valueOf(), // Convierte la fecha de inicio a milisegundos
                    marker: {
                        enabled: false
                    }
                }
            },
            series: data.map(item => ({
                name: item.name,
                color: color,
                data: item.data
            })),
            tooltip: {
                formatter(this: Highcharts.TooltipFormatterContextObject) {
                    const value = setearMiles(this.point.y ?? 0)
                    const prefix = showCurrency ? '$ ' : ''
                    return `${prefix}${value} <br/>  ${formatearFecha(new Date(this.point.x), 'MM/YYYY')}`
                }
            }
        }
        Highcharts.chart(containerId, (options as any) as Highcharts.Options)
    }

    useEffect(() => {
        crearGrafica()
    }, [updateData, data, showCurrency, containerId])

    return <div id={containerId} className="col-md-12 mx-auto"></div>
}

export default ChartVentasUltimoMes

